
import { setAnchorTagWithParams } from './common/common_util';
import { _axios } from './common/customAxios';
import { DEFAULT_ERROR_MESSAGE, ERROR_CODE_TO_MESSAGE_MAPPED } from './common/errorCode';
import { ApiErrorData, getErrorMessage, getErrorResult } from './common/errorMessageUtil';
import { callGetPlayer, callGetSurveyFlag, callPostCoupon, callPostSurvey } from './services';

const EVETN_CODE = 'test-1';

const CALENDAR = 'calendar';
const SURVEY = 'survey';

const IS_FINISH = 'is-finish';
const IS_ONGOING = 'is-ongoing';

const END_SELECTOR_BTN_COUPON = '__btn-coupon';
const END_SELECTOR_ANCHOR_SURVEY = 'survey__link';

const END_SELECTOR_CODE = '__code';

// const SELECTOR_BTN_COUPON = `[class$=${END_SELECTOR_BTN_COUPON}]`;
// const SELECTOR_ANCHOR_SURVEY = `[class$=${END_SELECTOR_ANCHOR_SURVEY}]`;
const SELECTOR_BTN_COUPON = '.attend-calendar__btn-coupon';
const SELECTOR_ANCHOR_SURVEY = '.attend-survey__link';
const SELECTOR_COUPON_CODE = `[class$=${END_SELECTOR_CODE}]`;

const COUPON_KEY_RUNTIME = [ '1','2','3','4','5','6','101','102'] as const;
const COUPON_KEY_CALENDAR_RUNTIME = [ '1','2','3','4','5','6'] as const;
const COUPON_KEY_SURVEY_RUNTIME = ['101','102'] as const;

const IS_OVER_SCHEDULE_CALENDAR = new Date() >= new Date('2023-05-30T23:59');
const IS_OVER_SCHEDULE_SURVEY = new Date() >= new Date('2023-06-04T23:59');

// modal
let ncuiToast: any;
let ncuiConfirm: any;
let ncuiAlert: any;

// DOM
let elAttendCalendarListWrap: HTMLUListElement;
let elAttendSurveyListWrap: HTMLUListElement;
let elCalendarListNodeList: NodeListOf<HTMLLIElement>;
let elSurveyListNodeList: NodeListOf<HTMLLIElement>;


document.addEventListener('DOMContentLoaded', () => {
  init();
});

async function init(){
  (document.querySelector('.container') as HTMLDivElement).style.display = 'none';

  // 변수 세팅
  setElementVariable();
  // HTML 세팅
  setDataCouponKey();

  // 로그인 안되어 있으면, 첫번째 출책 / 첫번째 설문 활성화 하고,
  if(!isLogin()){
    const elFirstCalendarList = [...elCalendarListNodeList][0];
    changToPossibleAndAddEventWithoutLogin(elFirstCalendarList);

    const elFirstSurveryList = [...elSurveyListNodeList][0];
    changToPossibleAndAddEventWithoutLogin(elFirstSurveryList);

    [...elSurveyListNodeList].map(e=>e.querySelector(SELECTOR_ANCHOR_SURVEY)!.removeAttribute('href'));

  } else {

    // 일단 유저의 정보를 불러오고
    // 유저의 설문조서 여부를 불러오고
    const playData = await sendCallGetPlayer();
    const surveyData = await sendCallGetSurveyFlag();

    if(!playData || !surveyData) {

      // await ncuiAlert.open({
      //   title: DEFAULT_ERROR_MESSAGE,
      //   confirmButtonText: '확인',
      // });

      location.href = '/';

      return;
    }

    const {couponMap, count, level} = playData;
    const {surveyFlagMap} = surveyData;

    // playData의 count를 통해 출석 버튼 활성화를 세팅하고
    // playData의 level 통해 설문 버튼 활성화를 세팅하고
    setPossible(count, level);

    // playData의 couponMap을 통해 '출석' / '설문' 버튼의 complete를 세팅하고,
    setCompleteByCouponMap(couponMap);

    // surveyData의 surveyFlagMap과, playData의 couponMap(101, 102)를 비교하여, 발급받지 않은 설문 쿠폰이 있는경우
    // 설문 쿠폰을 발급 받고,complete를 세팅한다.
    setCompleteBySuerveryFlag(surveyFlagMap);
  }

  // Anchor 태그에 search 파람 붙이기
  [...document.querySelectorAll('a')].map(ElAnchor => setAnchorTagWithParams(ElAnchor));

  (document.querySelector('.container') as HTMLDivElement).style.display = 'block';
}

// 로그인 여부 확인
function isLogin() {
  return window.isLoginFlag !== false && window.isLoginFlag !== 'false';
}

// 캘린더/설문 쿠폰 받기 활성화
function setPossible(count: number, level: number){
  setPossibleSurveyByCount(count);
  setPossibleCalendarByLevel(level);
}

// count에 따라 캘린더 쿠폰 받기 활성화
function setPossibleSurveyByCount(count: number){
  if(count === 0) return;

  for(let i = 1; (i <= count && i <= 6); i++){
    const targetElList = elCalendarListNodeList[i - 1];
    changToPossibleAndAddEvent(targetElList);
  }
}

// 레벨에 따라 설문 쿠폰 받기 활성화
function setPossibleCalendarByLevel(level: number){
  if(level < 10){
    return;
  }else{
    if(level >= 10){
      const targetElList = elSurveyListNodeList[0];
      changToPossibleAndAddEvent(targetElList);
    }
    if(level >= 22){
      const targetElList = elSurveyListNodeList[1];
      changToPossibleAndAddEvent(targetElList);
    }
  }
}

// 변수 세팅
function setElementVariable(){
  // ncui.modal
  ncuiToast = new window.ncui.modal.uiToast();
  ncuiConfirm = new window.ncui.modal.uiConfirm();
  ncuiAlert = new window.ncui.modal.uiAlert();

  // El
  elAttendCalendarListWrap = document.querySelector('.attend-calendar__list')!;
  elAttendSurveyListWrap = document.querySelector('.attend-survey__list')!;

  elCalendarListNodeList = elAttendCalendarListWrap.querySelectorAll('li')!;
  elSurveyListNodeList = elAttendSurveyListWrap.querySelectorAll('li')!;
}

// data-coupon-key 세팅
function setDataCouponKey (){
  const elCalendarList = elCalendarListNodeList;
  const elSurveyList = elSurveyListNodeList;

  // 캘린더 세팅
  COUPON_KEY_CALENDAR_RUNTIME.map((couponKey, idx) => {
    elCalendarList[idx].setAttribute('data-coupon-key', couponKey);
  });
  // 설문 세팅
  COUPON_KEY_SURVEY_RUNTIME.map((couponKey, idx) => {
    elSurveyList[idx].setAttribute('data-coupon-key', couponKey);
  });
}


function changToPossibleAndAddEventWithoutLogin(elList: HTMLLIElement){
  const couponType = elList.parentElement!.classList.contains('attend-calendar__list') ? CALENDAR : SURVEY;

  // elList
  elList.classList.remove(IS_FINISH, IS_ONGOING);
  elList.classList.add(IS_ONGOING);

  // 타입에 따라 분기처리
  if(couponType === CALENDAR){
    // 쿠폰 버튼
    const elBtnCoupon = (elList.querySelector(SELECTOR_BTN_COUPON) as HTMLButtonElement);
    elBtnCoupon.disabled = false;

    if(IS_OVER_SCHEDULE_CALENDAR){
      // [TODO] 레이어
      addClickEventOverSchedule(elBtnCoupon);
    }else{
      addClickEventLogin(elBtnCoupon);
    }

  // 설문 조사 타입
  }else{
    // 링크 버튼
    const elAnchorSurvey = (elList.querySelector(SELECTOR_ANCHOR_SURVEY) as HTMLAnchorElement);
    elAnchorSurvey.style.cursor = 'pointer';

    if(IS_OVER_SCHEDULE_SURVEY){
      // [TODO] 레이어
      addClickEventOverSchedule(elAnchorSurvey);
    }else{
      addClickEventLogin(elAnchorSurvey);
    }
  }
}

// Possible 변경하고 클릭 이벤트 바인딩
function changToPossibleAndAddEvent(elList: HTMLLIElement, isLogin = true){

  const couponType = elList.parentElement!.classList.contains('attend-calendar__list') ? CALENDAR : SURVEY;

  // elList
  elList.classList.remove(IS_FINISH, IS_ONGOING);
  elList.classList.add(IS_ONGOING);

  // 타입에 따라 분기처리
  if(couponType === CALENDAR){
    // 쿠폰 버튼
    const elBtnCoupon = (elList.querySelector(SELECTOR_BTN_COUPON) as HTMLButtonElement);
    elBtnCoupon.disabled = false;

    if(IS_OVER_SCHEDULE_CALENDAR){
      // [TODO] 레이어
      addClickEventOverSchedule(elBtnCoupon);
    }else{
      addClickEventToBtnCalendarCoupon(elBtnCoupon);
    }

    // 이벤트 바인딩
  // 설문 조사 타입
  }else{
    // 링크 버튼
    const elAnchorSurvey = (elList.querySelector(SELECTOR_ANCHOR_SURVEY) as HTMLAnchorElement);
    elAnchorSurvey.style.cursor = 'pointer';

    if(IS_OVER_SCHEDULE_SURVEY){
      // [TODO] 레이어
      addClickEventOverSchedule(elAnchorSurvey);
    }else{
      // href 따라감
    }

  }
}

function addClickEventOverSchedule(targetEl: HTMLButtonElement | HTMLAnchorElement){
  targetEl.addEventListener('click', async (e)=>{
    e.preventDefault();
    await ncuiAlert.open({
      title: '이벤트 기간이 아닙니다.',
      confirmButtonText: '확인',
    });
  });
}

// 미 로그인 상태에서 - 쿠폰 클릭했을때 로그인 페이지로 이동
function addClickEventLogin(targetEl: HTMLButtonElement | HTMLAnchorElement){
  targetEl.addEventListener('click', async (e)=>{
    e.preventDefault();
    window.GNBLogin();
  });
}

// CouponMap 에 따라complete 로 변경
function setCompleteByCouponMap(couponMap: ResponseGetPlayerData['couponMap'] ){
  Object.entries(couponMap).map(([key, value]) => {
    if(!value) return;

    const elList = document.querySelector(`[data-coupon-key="${key}"]`)  as HTMLElement;
    changToComplete(elList, value, true);
  });
}

// surveyData
function setCompleteBySuerveryFlag(surveyFlagMap: ResponseGetSurveyFlagData['surveyFlagMap']){
  ([...elSurveyListNodeList]).map((elLi, idx) => {
    // 실제로 사전예약 완료 했는가?
    const isCompleteSurvery = surveyFlagMap[idx + 1];

    // 쿠폰 발급 받았는가?
    const hasCompleteClass = elLi.classList.contains(IS_FINISH);

    if(isCompleteSurvery && !hasCompleteClass){
      const couponKey = elLi.dataset['couponKey'] as COUPON_KEY;
      sendCallPostCouponAndSet(couponKey);
    }
  });
}

// 완료 변경
function changToComplete(elList: HTMLElement, couponNumber: string, isComplete = true){
  const couponType = elList.parentElement!.classList.contains('attend-calendar__list') ? CALENDAR : SURVEY;

  // elList
  elList.classList.remove(IS_FINISH, IS_ONGOING);
  elList.classList.add(IS_FINISH);

  // 쿠폰 코드
  const elCouponCode = elList.querySelector(SELECTOR_COUPON_CODE)!;
  elCouponCode.innerHTML = couponNumber;

  if(couponType === CALENDAR){
    // 쿠폰 버튼
    const elBtnCoupon = (elList.querySelector(SELECTOR_BTN_COUPON) as HTMLButtonElement);
    elBtnCoupon.disabled = true;
  }else{
      // 링크 버튼
      const elAnchorSurvey = (elList.querySelector(SELECTOR_ANCHOR_SURVEY) as HTMLAnchorElement);
      elAnchorSurvey.addEventListener('click', e => {
        e.preventDefault();

        console.log('이미 발급받은 쿠폰이기때문에, 링크 이동 하지 않습니다!');
      });
  }
}


// 캘린더 - 쿠폰 클릭했을때 이벤트
function addClickEventToBtnCalendarCoupon(elBtnCoupon: HTMLButtonElement){
  elBtnCoupon.addEventListener('click', async ()=>{
    const couponKey = elBtnCoupon.parentElement!.dataset.couponKey! as COUPON_KEY_CALENDAR;

    await sendCallPostCouponAndSet(couponKey);
  });
}

// 쿠폰 받기 실행 + 쿠폰 상태를 완료 상태로 변경
async function sendCallPostCouponAndSet(couponKey: COUPON_KEY){

  const result = await sendCallPostCoupon(couponKey);

  if(result){
    // 완료 상태로 변경
    const {couponNo, couponValue} = result;
    const elList = document.querySelector(`[data-coupon-key="${couponKey}"]`) as HTMLElement;

    changToComplete(elList, couponValue, true);
  }
}


// 설문 - 쿠폰 클릭했을때 이벤트
// function addClickEventToBtnSurveyCoupon(elBtnCoupon: HTMLButtonElement){
//   elBtnCoupon.addEventListener('click',  ()=>{
//     const couponKey = elBtnCoupon.parentElement!.dataset.couponKey! as COUPON_KEY_SURVEY;

//     if(couponKey === '101'){
//       location.href = URL_PATH_FORM1;
//     }else{
//       location.href = URL_PATH_FORM2;
//     }
//   });
// }






/**
 * service
 */

// 설문 조사 여부 정보 조회
async function sendCallGetSurveyFlag(): Promise<ResponseGetSurveyFlagData | false>{
  try{

    const result = (await callGetSurveyFlag({eventCode: EVETN_CODE})).data;
    // const result = {surveyFlagMap:{
    //   0: true,
    //   1: true,
    //   2: false // 이거
    // }};

    return result;
  }catch(error){
    if (_axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});

      await ncuiAlert.open({
        title: errorMessage,
        confirmButtonText: '확인',
      });

      return false;
    }else{
      throw error;
    }
  }
}

// 게임 플레이 정보 조회
async function sendCallGetPlayer(): Promise<ResponseGetPlayerData | false>{
  try{
    const result = (await callGetPlayer({eventCode: EVETN_CODE})).data;
    // const result = {
    //   level: 23,
    //   count: 5,
    //   logDate: '',
    //   couponMap: {
    //     '1': '123123123',
    //     '2': '123123123',
    //     '3': '123123123',
    //     '4': '',
    //     '5': '',
    //     '6': '',
    //     '101': '',
    //     '102': '',
    //   }
    // };

    return result;
  }catch(error){
    if (_axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});

      await ncuiAlert.open({
        title: errorMessage,
        confirmButtonText: '확인',
      });

      return false;
    }else{
      throw error;
    }
  }
}


// 쿠폰 발급
async function sendCallPostCoupon(couponNo: COUPON_KEY): Promise<ResponsePostCouponData | false>{
  try{
    console.log(couponNo);

    const result = (await callPostCoupon({eventCode: EVETN_CODE, couponNo})).data;
    // const result = {
    //   couponNo: couponNo,
    //   couponValue: 'testcoupon' + couponNo
    // };

    return result;

  }catch(error){
    if (_axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, ERROR_CODE_TO_MESSAGE_MAPPED, {DEFAULT_ERROR_MESSAGE});

      await ncuiAlert.open({
        title: errorMessage,
        confirmButtonText: '확인',
      });

      return false;
    }else{
      throw error;
    }
  }
}
